// extracted by mini-css-extract-plugin
export default {"option":"TransactionsStatusDropdown_option__Bx9c7","eye":"TransactionsStatusDropdown_eye__e0GkQ","clipboardNotes":"TransactionsStatusDropdown_clipboardNotes__Td0fo"};